const NakedInput = (field) => {
  return (
    <input
      {...field.input}
      type={field.type || 'hidden'}
      placeholder={field.placeholder} />
  )
}

export default NakedInput
